module.exports = __webpack_public_path__ + "static/media/sendgrid-full.ec0c65fb.svg";